declare global {
  interface Window {
    dataLayer: Content[]
    result: {
      clickURL: string
    }
    AF_SMART_SCRIPT: {
      displayQrCode: (url: string) => void
    }
  }
}

interface Content {
  event: string
  params: Params
  params_input: unknown
}

interface Params {
  section_name: string
  element_action: string
  element_name: string
  c_page: string
  redirect_url: string | unknown
  step: unknown
}

export default {
  enviar(content: Content) {
    window?.dataLayer?.push(content)
  },
}
